import './index.css';

import React, { useEffect, useState } from 'react';

import http from '../../../api/http';
import RecordSection from '../../view/RecordSection';

const formatDate = (value) => {
  if (!value) return null;
  const date = new Date(`${value}T12:00:00`);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString();
};

const SprintPackForecastSection = ({ section, id }) => {
  const [forecast, setForecast] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    const loadForecast = async () => {
      setLoading(true);
      setError('');
      setForecast(null);
      try {
        const { data } = await http.get(`/foundations/records/${encodeURIComponent(section)}/${encodeURIComponent(id)}/forecast`);
        if (!data || !data.status || !data.velocity) throw new Error('The forecast response was incomplete.');
        if (active) setForecast(data);
      } catch (requestError) {
        if (active) setError(requestError?.response?.data?.message || requestError.message || 'Unable to load SprintPack forecast.');
      } finally {
        if (active) setLoading(false);
      }
    };

    if (section && id) loadForecast();
    return () => { active = false; };
  }, [section, id]);

  return (
    <RecordSection title="Sprint completion forecast" className="sprint-forecast">
      {loading ? <p>Calculating forecast...</p> : null}
      {error ? <p className="error-text">{error}</p> : null}
      {!loading && !error && forecast ? (
        <>
          <p>
            {forecast.status === 'complete'
              ? 'All tasks in this SprintPack are complete.'
              : forecast.forecastDate
                ? `At the observed pace, completion is projected for ${formatDate(forecast.forecastDate)}.`
                : 'There is not enough recent completion history to project a finish date.'}
          </p>
          <p className="sprint-forecast-velocity">
            {forecast.completedTasks} of {forecast.completedTasks + forecast.remainingTasks} tasks complete
            {forecast.velocity.completedTasks
              ? ` · ${forecast.velocity.completedTasks} completions across the last ${forecast.velocity.windowDays} days`
              : ''}
          </p>
          {forecast.uncertainty ? (
            <p className="muted-text">
              Illustrative {Math.round(forecast.uncertainty.confidenceLevel * 100)}% range: {formatDate(forecast.uncertainty.lowerDate)}–{formatDate(forecast.uncertainty.upperDate)}.
            </p>
          ) : null}
          <p className="muted-text">{forecast.assumptions.join(' ')}</p>
        </>
      ) : null}
    </RecordSection>
  );
};

export default SprintPackForecastSection;
